<template>
  <div>
      <hr />

      <p>
        <strong>Enfant {{ parseInt(index)+1 }}</strong>
      </p>

      <div class="form-group" :class="{ 'error': $v.child.first_name.$error }">
        <label :for="'child_first_name'+index">Prénom de l’enfant disparu</label>
        <div class="input-group">
          <input type="text" name="child_first_name" :id="'child_first_name'+index" v-model.trim="$v.child.first_name.$model" required />
          <p class="form-error" v-if="$v.child.first_name.$error && !$v.child.first_name.required">
            Ce champ est obligatoire
          </p>
        </div>
      </div>

      <div class="form-group" :class="{ 'error': $v.child.last_name.$error }">
        <label :for="'child_last_name'+index">Nom de l’enfant disparu</label>
        <div class="input-group">
          <input type="text" name="child_last_name" :id="'child_last_name'+index" v-model.trim="$v.child.last_name.$model" required />
          <p class="form-error" v-if="$v.child.last_name.$error && !$v.child.last_name.required">
            Ce champ est obligatoire
          </p>
        </div>
      </div>

      <div class="form-group" :class="{ 'error': $v.child.age.$error }">
        <label :for="'child_age'+index">Âge de l’enfant disparu</label>
        <div class="input-group">
          <input type="text" name="child_age" :id="'child_age'+index" v-model.trim="$v.child.age.$model" required />
          <p class="form-error" v-if="$v.child.age.$error && !$v.child.age.required">
            Ce champ est obligatoire
          </p>
          <p class="form-error" v-if="$v.child.age.$error && !$v.child.age.numeric">
            Veuillez entrer un nombre
          </p>
          <p class="form-error" v-if="$v.child.age.$dirty && $v.child.age.required && $v.child.age.$error && !$v.child.age.between">
            L’enfant doit être âgé de {{ $v.child.age.$params.between.min }} à {{ $v.child.age.$params.between.max }} ans
          </p>
        </div>
      </div>

  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, numeric, between, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'MissingChildIntakeFormChild_fr',

  props: {
    child: { type: Object, required: true },
    index: { type: Number, required: true }
  },

  mixins: [validationMixin],

  data() {
    return {

    }
  },

  validations() {
    let v = {
      child: {
          first_name: { required },
          last_name: { required },
          age: {
            required,
            numeric,
            between: between(0, 99)
          },
      }
    }

    return v
  },

  methods: {
  },

}
</script>



// WEBPACK FOOTER //
// js/MissingChildIntakeFormChild_fr.vue